<template>
    <v-form :name="props.searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList>
                <Tab value="0">{{ __('Search condition') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="last_name"
                                       label="Last name"
                                       size="3"
                                       :isFocus="true"
                                       v-model:field="search.last_name" />

                        <FormInputText fieldName="first_name"
                                       label="First name"
                                       size="3"
                                       v-model:field="search.first_name" />

                        <FormInputText fieldName="email"
                                       label="Email"
                                       size="3"
                                       v-model:field="search.email" />

                        <FormMultiselect fieldName="provider_id"
                                         label="Provider"
                                         size="3"
                                         :options="select?.providers"
                                         :filter="(event) => onFilter(event, 'providers')"
                                         v-model:field="search.provider_id" />
                    </div>
                    <div class="grid">
                        <FormSelect fieldName="is_locked"
                                    label="Is user locked?"
                                    size="2"
                                    scrollHeight="100px"
                                    :showClear="true"
                                    :filtering="false"
                                    :options="yesNoOptions()"
                                    v-model:field="search.is_locked" />

                        <FormSelect fieldName="is_active"
                                    label="Is active user?"
                                    size="2"
                                    scrollHeight="100px"
                                    :showClear="true"
                                    :filtering="false"
                                    :options="yesNoOptions()"
                                    v-model:field="search.is_active" />

                        <FormSelect fieldName="is_password_policy"
                                    label="Is password policy?"
                                    size="2"
                                    scrollHeight="100px"
                                    :showClear="true"
                                    :filtering="false"
                                    :options="yesNoOptions()"
                                    v-model:field="search.is_password_policy" />

                        <FormMultiselect fieldName="role_id"
                                         label="Role"
                                         size="6"
                                         showClear
                                         :options="select?.roles"
                                         :filter="(event) => onFilter(event, 'roles')"
                                         v-model:field="search.roles" />
                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>


        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from "@crud/FormInputText.vue";
import FormMultiselect from "@crud/FormMultiselect.vue";
import FormSelect from "@crud/FormSelect.vue";

import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch, yesNoOptions } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})
const autoSearch = ref(false)

const options = ["roles", "providers"];
const select = ref(null);

let search = ref({})

prepareSearch(search, props, options, select)

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
